module.exports = __webpack_public_path__ + "static/media/n_icon_video.73fdbe75.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_video.png
// module id = 1819
// module chunks = 0 1